export default __webpack_public_path__ + "static/media/about-image.1e482395.jpg";